<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="usersLimit"
				textCreate="Add user"
				flag="users"
				page-title="Users"
				:headers="headers"
				:settings="getSettings"
				:filtersList="usersFilters"
				:list="usersList"
				:defaultOrder="usersOrder"
				:defaultSort="usersSort"

				:totals="usersTotals"
				:total-pages="usersTotal"
				:limit-pages="usersLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				is-settings
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('users')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>

		<user-form
				v-if="isUsersForm"
				@updateClose="onCloseDialog"
				:userId="userId"
		></user-form>

	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import UserForm from "@/components/Maintenance/Users/UsersForm/UsersForm";
// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "Users",
	mixins: [ settingsMixins, removeMixins ],
	components: { UserForm, MainTableAllBack },
	computed: mapGetters([
		"usersList",
		"usersFilters",
		"usersTotals",
		"permissions",
		"usersOrder",
		"usersLimit",
		"usersSort",
		"usersTotal",
	]),
	data: () => ({
		isUsersForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		userId: null,
	}),
	methods: {
		...mapActions([ 'getUsers', 'getUsersFilters', 'actionPreloader', 'onExportLink', 'onUsersRemoveItem' ]),
		onCloseDialog(isRefresh) {
			this.isUsersForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},
		async onRemoveItem() {
			const { status } = await this.onUsersRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			await this.onUpdateFilters(this.defaultFilter);
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isUsersForm = true;
				this.userId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getUsers(filters);
			if (!isWithoutFilters) await this.getUsersFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getUsers(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'users' });
		},
		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.userId = item.id;
					this.isUsersForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}
		},
		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.userId = line.id;
				this.isUsersForm = true;
			}
		},

	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>
